import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { StudioProvider } from '@/features/studio';
import { createQueryClient } from './query-client';

/** App-wide state. The router is added by the caller (BrowserRouter in main.tsx, MemoryRouter in tests). */
export function AppProviders({ children, queryClient }: { children: ReactNode; queryClient?: QueryClient }) {
  const [client] = useState(() => queryClient ?? createQueryClient());
  return (
    <QueryClientProvider client={client}>
      <StudioProvider>{children}</StudioProvider>
    </QueryClientProvider>
  );
}
